export default (state = {}) => {
  return {
    ...state,
    isPopoverOpen: true,
  };
};
